import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form, Card } from "react-bootstrap";

// import AddToEnterpriseElement from "../../AddSingleSite/AddToEnterpriseElement";
import AddToEnterpriseSiteEditor from "./AddToEnterpriseSiteEditor.js";

import conxtdOut from "apis/conxtdOut";
import Axios from "../../../../../../node_modules/axios/index";

import SingularAssociation from "./SingularAssociation";
import { useIsMounted } from "components/Common/CustomHooks/useIsMounted";

function EnterpriseAssociations({ 
  arcmap_id,
  companyId,
  invalidEnterprise,
  setInvalidEnterprise,
  setAddToEnterpriseData,
  sudoSiteId,
  initialiseFormDataTrigger,
  setInitialiseFormDataTrigger,
  windowSize,
  siteCount,
  setTooltipDescription,
  setShowEditButton,
  changeDetected,
  setChangeDetected,
  setAlternateEditStyle,
  editMode,
  setEditMode,
  alternateEditStyle,
  setDisableEditButton,
  toggleEditMode,
  initialFormData,
  setInitialFormData,
  editData,
  setEditData,
  selectedOption,
  setEditSubmissionType,
}) {

  const darkMode = useSelector((state) => state.app.darkMode)
  const associations = useSelector((state) => state.serviceDesk.enterpriseAssociations);

  const [enterpriseAssociations, setEnterpriseAssociations] = useState([]);
  const [mappedAssociations, setMappedAssociations] = useState([]);
  const [addToEnterprise, setAddToEnterprise] = useState(false);

  const [name, setName] = useState("");
  const [custom_site_ref, setCustomSiteRef] = useState("");
  const [enterprise, setEnterprise] = useState("");
  const [billing_status, setBillingStatus] = useState("");
  const [enterprise_groups, setEnterpriseGroups] = useState("");
  const [enterpriseCustomFieldsData, setEnterpriseCustomFieldsData] = useState([]);
  // const [enterpriseSiteId, setEnterpriseSiteId] = useState(null);

  // populate form state
  const [formBillingStatus, setFormBillingStatus] = useState([]);
  const [formEnterprises, setFormEnterprises] = useState(null);
  const [unformattedFormEnterprises, setUnformattedFormEnterprises] = useState([]);
  const [formEnterpriseGroups, setFormEnterpriseGroups] = useState([]);
  const [loadingEnterpriseList, setLoadingEnterpriseList] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [editAvailable, setEditAvailable] = useState(true);

  const isMounted = useIsMounted();

  const initialiseFormData = () => {
    setName("");
    setCustomSiteRef("");
    setEnterprise(null);
    setBillingStatus("");
    setEnterpriseGroups(null);
    setEnterpriseCustomFieldsData([]);
    setFormEnterpriseGroups([]);
    setEditMode(false);
    setAlternateEditStyle(false);
    setEditData([]);
    setInitialFormData([]);
    setChangeDetected(false);
  }

  const mapCustomFields = (state, setState) => {
    const groupedFields = [];
    const entries = Object.entries(state);
    
    for (let i = 0; i < entries.length; i += 2) {
      groupedFields.push(entries.slice(i, i + 2));
    }

    const render = groupedFields.map((group, index) => (
      <div className="row" key={index}>
        {group.map(([key, value]) => (
          <Form.Group className="col-6" key={key}>
            <Form.Label>{value}</Form.Label>
            <Form.Control
              name={key}
              className='form-input'
              onChange={(e) => {
                const newVal = e.target.value;
                const fieldName = e.target.name;
                setState((prev) => {
                  const updatedFields = { field_id: fieldName, value: newVal };
                  const existingIndex = prev.findIndex(field => field.field_id === fieldName);
  
                  if (existingIndex !== -1) {
                    const updatedState = [...prev];
                    updatedState[existingIndex] = updatedFields;
                    return updatedState;
                  } else {
                    return [...prev, updatedFields];
                  }
                });
              }}
            />
          </Form.Group>
        ))}
      </div>
    ));

    return render;
  }

  const smallScreenModalLabels = () => {
    return (
      <div className='d-flex justify-content-between flex-nowrap'>
        <Form.Label className="col label-title-ent-name justify-content-start mb-0">Enterprise</Form.Label>
        <Form.Label className="col label-title justify-content-start mb-0">Site</Form.Label>
        <Form.Label className="col d-flex label-title justify-content-center mb-0">Actions</Form.Label>
      </div>
  )}

// USE EFFECT HOOKS --
useEffect(() => {
  setEditSubmissionType(!addToEnterprise);
}, [addToEnterprise])

useEffect(() => {
  setEditMode(false);
  setEditAvailable(selectedOption === 'Enterprise Associations')

  return () => {
    setEditMode(false);
    setDisableEditButton(false);
  }
}, [selectedOption])

useEffect(() => {
  if (addToEnterprise) {
    setTooltipDescription(
      <ul className="m-0 pl-3 text-left">
        {invalidEnterprise ? <li key={4}>required field(s) are empty</li> : null}
      </ul>
    )
  }
}, [setTooltipDescription, invalidEnterprise, addToEnterprise])

useEffect(() => {
  if (!disabled) {
    const values = { name, custom_site_ref, enterprise, billing_status, enterprise_groups }
    let mapped = Object.values(values);
    (Array.isArray(enterpriseCustomFieldsData) && enterpriseCustomFieldsData.length > 0) && mapped.push(Object.values(enterpriseCustomFieldsData));
    setChangeDetected(mapped.some(value => Boolean(value)));
  }
}, [name, custom_site_ref, enterprise, billing_status, enterprise_groups, enterpriseCustomFieldsData])

useEffect(() => {
  if (initialiseFormDataTrigger) {
    initialiseFormData();
    setInitialiseFormDataTrigger(false);
  }
}, [initialiseFormDataTrigger, setInitialiseFormDataTrigger])

useEffect(() => {
  if (associations) {
    setEnterpriseAssociations(associations);
  }
}, [associations])

useEffect(() => {
  const source = Axios.CancelToken.source();
  if (isMounted && companyId && sudoSiteId && arcmap_id) {
    const getFrontendFormData = conxtdOut.get(`/ServiceDesk/getFrontendFormData/${companyId}`, { cancelToken: source.token });
    setLoadingEnterpriseList(true);
    getFrontendFormData.then((response) => {
      const data = response.data?.[0];
      setFormBillingStatus(Object.entries(data['billingStatus']).map(([key, value]) => {
        return {label: value, value: key}
      }))
      setUnformattedFormEnterprises(Object.entries(data['enterprises']).length > 0 ? Object.entries(data['enterprises']) : []);
      setLoadingEnterpriseList(false);
    }).catch((error) => {
      console.log(error);
      setLoadingEnterpriseList(false);
    })
  }

  return () => {
    source.cancel("Component unmounted: request canceled");
  }
}, [companyId, arcmap_id, sudoSiteId, isMounted])

useEffect(() => {
  if (loadingEnterpriseList === false) {
    if (unformattedFormEnterprises.length > 0) {
      const enterpriseIds = enterpriseAssociations?.map(item => item?.enterprise?.id) ?? [];

      const results =
        unformattedFormEnterprises.map(([key, value]) => {
          return enterpriseIds.includes(value) ? null : [key, value];
        }
      );
      
      const filtered = results
        .filter(item => item !== null)
        .map(([key, value]) => ({ label: key, value }));

      setFormEnterprises(filtered);
    } else if (unformattedFormEnterprises.length === 0 && enterpriseAssociations.length === 0) {
      setFormEnterprises([]);
    } else {
      return;
    }
  } else {
    return;
  }
}, [enterpriseAssociations, unformattedFormEnterprises, loadingEnterpriseList]);

useEffect(() => {
  setMappedAssociations(enterpriseAssociations?.map((item) => (
    {
      name: item?.name ?? "",
      customSiteId: item?.custom_site_id ?? "",
      enterpriseId: item?.enterprise?.id ?? "",
      billingStatus: item?.billing_status ?? "",
      groups: item?.groups ?? "",
    })
  ))
}, [enterpriseAssociations])

useEffect(() => {
  setAddToEnterpriseData({
    name,
    enterprise,
    custom_site_ref,
    billing_status,
    groups: Array.isArray(enterprise_groups) ? enterprise_groups.map(group => group?.value) : [],
    enterprise_custom_fields: enterpriseCustomFieldsData,
  })
}, [
  name, 
  enterprise, 
  custom_site_ref, 
  billing_status, 
  enterprise_groups, 
  enterpriseCustomFieldsData, 
  setAddToEnterpriseData
])

  return (
    <>
      <div className='w-100' id='enterprise-associations-container' data-intercom-target={"enterprise-associations-container"}>
        <div className={`d-flex justify-content-center ${darkMode ? "darkMode" : ""} w-100 card-body p-0`}>
          <Row className="w-100">
            <Col className="p-0">
              {enterpriseAssociations.length > 0 ?
                <div id="enterprise-associations-card">
                  <Card className="enterprise-associations-header m-0 pt-2 pb-2 pl-2 pr-3">
                    {windowSize.width > 700 ?
                      <Row className='d-flex justify-content-between flex-nowrap'>
                        <Col md={editMode && !alternateEditStyle ? 2 : 3} lg={editMode && !alternateEditStyle ? 2 : 3} className="label-title-ent-name justify-content-start mb-0"><Form.Label>Enterprise</Form.Label></Col>
                        <Col md={editMode && !alternateEditStyle ? 2 : 3} lg={editMode && !alternateEditStyle ? 2 : 3} className="label-title justify-content-start mb-0"><Form.Label>Site</Form.Label></Col>
                        <Col md={2} lg={2} className="label-title justify-content-start mb-0"><Form.Label>Custom Ref</Form.Label></Col>
                        <Col md={editMode && !alternateEditStyle ? 2 : 3} lg={editMode && !alternateEditStyle ? 2 : 3} className="label-title justify-content-start mb-0"><Form.Label>Groups</Form.Label></Col>
                        <Col md={2} lg={2} className="label-title justify-content-start mb-0"><Form.Label>Billing</Form.Label></Col>
                        {/* <Collapse in={(editMode && !alternateEditStyle)}> */}
                        {(editMode && !alternateEditStyle) ?
                            <Col md={2} lg={1} className={`d-flex label-title justify-content-center mb-0 ${editMode && !alternateEditStyle ? "" : "hide-section"}`}>
                              <Form.Label>Actions</Form.Label>
                          </Col>
                        : 
                          <></>
                        }
                        {/* </Collapse> */}
                      </Row>
                    :
                      windowSize.width > 500 ? 
                        smallScreenModalLabels() 
                      : 
                        <div className='d-flex justify-content-center flex-wrap flex-column pl-1 pr-1'>
                            <Form.Label className="label-title-ent-name-small mb-2">Associated Enterprise Sites: {siteCount}</Form.Label>
                            <p className="d-flex justify-content-center">Rotate mobile device to view Enterprise Associations table</p>
                        </div>
                    }
                  </Card>
                  {enterpriseAssociations && windowSize.width >= 500 ?
                    enterpriseAssociations.map((association, index) => (
                      <SingularAssociation
                        key={index}
                        index={index}
                        enterpriseName={association.enterprise.name}
                        enterprise_id={association.enterprise.id}
                        group_ids={association?.enterprise_groups ? Object.values(association?.enterprise_groups)?.map(group => group) : null}
                        groups={
                          association?.enterprise_groups ? 
                            Object.entries(association?.enterprise_groups)
                              ?.filter(([key, value]) => value?.isRoot || !value?.isParent)
                              ?.map(([key, value]) => value)
                          : null
                        }
                        siteName={association.name}
                        customRef={association.custom_site_id}
                        billingStatus={association.billing_status}
                        sudoSiteId={sudoSiteId}
                        enterpriseSiteId={association.id}
                        enterpriseLogo={association.enterprise.logo_dir}
                        windowSize={windowSize}
                        editMode={editMode}
                        alternateEditStyle={alternateEditStyle}
                        setInitialiseFormDataTrigger={setInitialiseFormDataTrigger}
                        initialiseFormDataTrigger={initialiseFormDataTrigger}
                        initialFormData={initialFormData}
                        setInitialFormData={setInitialFormData}
                        setEditData={setEditData}
                        editData={editData}
                        changeDetected={changeDetected}
                        setChangeDetected={setChangeDetected}
                        setTooltipDescription={setTooltipDescription}
                        setInvalidEnterprise={setInvalidEnterprise}
                        addToEnterprise={addToEnterprise}
                      />
                    ))
                  :
                    <></>
                  }
                </div>
              :
                <div id="enterprise-associations-card">
                  <Card className="enterprise-associations-header m-0 p-2">
                    <h6>No enterprise associations detected.</h6>
                  </Card>
                </div>
              }
            </Col>
          </Row>
        </div>
        <div className="m-0 pb-3">
          {isMounted && <AddToEnterpriseSiteEditor
            accordionStyle={true}
            enterprise={enterprise}
            setEnterprise={setEnterprise}
            name={name}
            setName={setName}
            custom_site_ref={custom_site_ref}
            setCustomSiteRef={setCustomSiteRef}
            billingStatus={billing_status}
            setBillingStatus={setBillingStatus}
            enterprise_groups={enterprise_groups}
            setEnterpriseGroups={setEnterpriseGroups}
            enterpriseCustomFieldsData={enterpriseCustomFieldsData}
            setEnterpriseCustomFieldsData={setEnterpriseCustomFieldsData}
            invalidEnterprise={invalidEnterprise}
            setInvalidEnterprise={setInvalidEnterprise}
            formBillingStatus={formBillingStatus}
            formEnterprises={formEnterprises}
            addToEnterprise={addToEnterprise}
            setAddToEnterprise={setAddToEnterprise}
            mapCustomFields={mapCustomFields}
            formEnterpriseGroups={formEnterpriseGroups}
            setFormEnterpriseGroups={setFormEnterpriseGroups}
            initialiseFormDataTrigger={initialiseFormDataTrigger}
            setInitialiseFormDataTrigger={setInitialiseFormDataTrigger}
            loadingEnterpriseList={loadingEnterpriseList}
            enterpriseAssociations={enterpriseAssociations}
            mappedAssociations={mappedAssociations}
            changeDetected={changeDetected}
            disabled={disabled}
            setDisabled={setDisabled}
            setShowEditButton={setShowEditButton}
            setAlternateEditStyle={setAlternateEditStyle}
            alternateEditStyle={alternateEditStyle}
            editMode={editMode}
            setEditMode={setEditMode}
            setDisableEditButton={setDisableEditButton}
            associations={associations}
            toggleEditMode={toggleEditMode}
            editAvailable={editAvailable}
            // setEditSubmissionType={setEditSubmissionType}
          />}
        </div>
      </div>
    </>
  )
}

export default EnterpriseAssociations
